var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHighlight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 97C54.978 97 63.7904 95.8638 71.5117 91.405C79.2331 86.9463 85.5786 80.5463 89.882 72.877C94.1852 65.2076 96.2877 56.552 95.9683 47.8191C95.649 39.0859 92.1026 31.3521 87.25 24L85.375 25.2167C89.7737 31.8812 91.0057 40.0646 91.2952 47.9809C91.5846 55.8972 89.6789 63.7434 85.778 70.6954C81.8771 77.6475 76.1251 83.449 69.1257 87.4907C62.1265 91.5324 54.1384 95.175 46 95.175V97Z",
    fill: "#F64E60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 83.984C27.9598 86.6833 31.5592 89.1408 35.9302 90.0932C40.7662 91.147 45.8168 91.237 51 90.5972V87.9519C46.3251 88.5289 41.6569 88.0586 37.186 86.7423C33.1023 85.5399 28.8651 84.4605 25.2558 82L24 83.984Z",
    fill: "#F64E60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54 2C45.022 2 36.2096 3.15181 28.4883 7.67161C20.7669 12.1914 14.4214 18.6791 10.118 26.4534C5.81478 34.2279 3.71228 43.002 4.03165 51.8547C4.35103 60.7074 7.8974 68.5472 12.75 76L14.625 74.7667C10.2263 68.0108 8.99428 59.7153 8.70478 51.6906C8.4154 43.6658 10.3211 35.7122 14.222 28.6649C18.1229 21.6176 23.8749 15.7366 30.8743 11.6396C37.8735 7.54248 45.8616 3.85 54 3.85V2Z",
    fill: "#F64E60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76 16.016C72.0402 13.3167 68.4408 10.8592 64.0698 9.90677C59.2338 8.85302 54.1832 8.76295 49 9.40285V12.0481C53.6749 11.4711 58.3431 11.9414 62.814 13.2577C66.8977 14.4601 71.1349 15.5395 74.7442 18L76 16.016Z",
    fill: "#F64E60"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlight);
export default __webpack_public_path__ + "static/media/highlight.2d41c237166a71a45f2b543ca4976c58.svg";
export { ForwardRef as ReactComponent };